import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Home, BookOpen, Tag, TrendingUp, Clock } from 'lucide-react';
import { useAuthStore, useUIStore, useGenreStore } from '../../hooks/useStore';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const { logout } = useAuthStore();
  const { isSidebarOpen, closeSidebar } = useUIStore();
  useGenreStore();



  const navLinks = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/novels', icon: BookOpen, label: 'All Novels' },
    { path: '/genres', icon: Tag, label: 'Genres' },
    { path: '/novels?sort=popular', icon: TrendingUp, label: 'Hot' },
    { path: '/novels?sort=newest', icon: Clock, label: 'Latest' },
  ];

  return (
    <>
      <div className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`} onClick={closeSidebar} />
      
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-title">Menu</span>
          <button className="close-btn" onClick={closeSidebar}>
            <X size={20} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-item ${location.pathname === link.path ? 'active' : ''}`}
              onClick={closeSidebar}
            >
              <link.icon size={18} />
              <span>{link.label}</span>
            </Link>
          ))}
        </nav>
        
      </aside>
    </>
  );
};

export default Sidebar;
